import { BasePage } from '@components/BaseHome';
import { SEOHead } from '@components/seo';

export default function CheckoutPaymentConfirm() {
  return (
    <>
      <SEOHead title="Meki · Metodo de pago" />
      <BasePage />
    </>
  );
}
